export default __webpack_public_path__ + "static/media/naran.557537c2.jpg";